<template>
    <p class="fw-bold">
        {{ __('messages.dashboard.widgets.admin.cronjobs.cronjobs') }}
    </p>
    <DTabs
        bs
        class="mb-3"
    >
        <DTabItem
            id="critical-jobs"
            :active="activeTab === 'critical_jobs'"
            :label="__('messages.dashboard.widgets.admin.cronjobs.critical_jobs')"
            @click="setActiveTab('critical_jobs')"
        />
        <DTabItem
            id="deactivated-jobs"
            :active="activeTab === 'deactivated_jobs'"
            @click="setActiveTab('deactivated_jobs')"
        >
            <div class="notification">
                <span>{{ __('messages.dashboard.widgets.admin.cronjobs.deactivated_jobs') }}</span>
                <span class="badge">{{ deactivatedCronJobs }}</span>
            </div>
        </DTabItem>
    </DTabs>
    <DCard
        v-if="activeTab==='critical_jobs'"
        class="card"
    >
        <DCardBody>
            <DTable
                :items="criticalJobs"
                :fields="criticalJobFields"
            >
                <template #job="{item}">
                    <td>
                        <Link :href="route('administrations.cron-jobs.edit', {cron_job: item.id})">
                            {{ item.job }}
                        </Link>
                    </td>
                </template>
                <template #summary="{item}">
                    <td>
                        {{ item.summary ?? '' }}
                    </td>
                </template>
            </DTable>
        </DCardBody>
    </DCard>
    <DCard
        v-if="activeTab==='deactivated_jobs'"
        class="mb-3 card"
    >
        <DCardBody>
            <DTable
                :items="deactivatedJobs"
                :fields="deactivatedJobFields"
            >
                <template #job="{item}">
                    <td>
                        <Link :href="route('administrations.cron-jobs.edit', {cron_job: item.id})">
                            {{ item.job }}
                        </Link>
                    </td>
                </template>
            </DTable>
        </DCardBody>
    </DCard>
    <DButton
        class="mt-3"
        :label="__('messages.dashboard.widgets.admin.cronjobs.redirect_button')"
        color="secondary"
        :href="route('administrations.cron-jobs.index')"
    />
</template>

<script setup>
import { ref, computed } from 'vue'
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'

const activeTab = ref('critical_jobs')

const criticalJobFields = ref(
    [
        { key: 'job', label: __('messages.dashboard.widgets.admin.cronjobs.job') },
        { key: 'summary', label: __('messages.dashboard.widgets.admin.cronjobs.summary') }
    ]
)

const deactivatedJobFields = ref(
    [
        { key: 'job', label: __('messages.dashboard.widgets.admin.cronjobs.job') },
        { key: 'error', label: __('messages.dashboard.widgets.admin.cronjobs.error') }
    ]
)

const props = defineProps({
    cronjobData: {
        type: Object,
        default () {
            return {}
        }
    }
})

const deactivatedJobs = computed(() => {
    if (!props.cronjobData.deactivatedJobs) return []
    return props.cronjobData.deactivatedJobs.map(job => {
        return {
            job: job.job,
            id: job.id,
            error: job.summary === null
                ? __('administrations.cron_jobs.messages.manually_disabled')
                : __('administrations.cron_jobs.messages.' + job.job + '.' + job.summary)
        }
    })
})

const criticalJobs = computed(() => {
    if (!props.cronjobData.criticalJobs) return []
    return props.cronjobData.criticalJobs.map(job => {
        return {
            job: job.job,
            id: job.id,
            summary: job.summary
        }
    })
})

const deactivatedCronJobs = computed(() => {
    if (!props.cronjobData.deactivatedJobs || props.cronjobData.deactivatedJobs.length === 0) return null

    return props.cronjobData.deactivatedJobs.length
})

function setActiveTab (tab) {
    activeTab.value = tab
}

</script>

<style>
.notification {
    position: relative;
    display: inline-block;
}
.notification .badge {
    position: absolute;
    top: -20px;
    right: -20px;
    padding: 5px 10px;
    border-radius: 50%;
    background: red;
    color: white;
}
</style>
